/**
 * COM-9.12 — reading the contract-storage sweeper's health.
 *
 * ⚠️ THIS MODULE HOLDS NO RULES. What the answer MEANS is
 * `lib/contractStorageSweep.ts`.
 *
 * ⚠️ THERE IS NO "RUN NOW" HERE, DELIBERATELY. The sweep endpoint is guarded by a
 * shared secret that the browser must never hold: it is the same secret pg_cron
 * presents, and an endpoint that DELETES storage objects cannot be reachable from
 * a bundle that ships to every user. The card reports; the schedule acts.
 *
 * ⚠️ ERRORS ARE THROWN, NOT SWALLOWED. `contract_storage_sweep_health()` REFUSES a
 * non-superadmin rather than answering an empty object, and a card that rendered
 * that refusal as a green tick would be worse than no card.
 */

import { supabase } from '@/lib/supabaseClient';
import type { ContractSweepHealth } from '@/lib/contractStorageSweep';

export async function fetchContractSweepHealth(): Promise<ContractSweepHealth> {
  const { data, error } = await supabase.rpc('contract_storage_sweep_health');
  if (error) throw new Error(`Could not read contract storage sweep health: ${error.message}`);
  if (!data) throw new Error('Contract storage sweep health returned nothing.');
  return data as ContractSweepHealth;
}
